import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  TextAndFileInputDialog30838dtq38cw5 as TextAndFileInputDialog,
  Submission1tz7ozccph0bt as Submission,
} from '../../../dialogs/TextInputDialog.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../nav/crowpay.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  plus2opbwe063z9pg as plus,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { coerceAtMostfyc3emgaderp as coerceAtMost } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { timesx4ey3un7ihw1 as times } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { GroupedInformationSemantic_getInstance10la8ntbgzaf6 as GroupedInformationSemantic_getInstance } from '../../../theming/appTheme.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
} from '../../../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../nav/AppDimensions.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../files/renderFiles.mjs';
import { labeledSection16775qn7m7foh as labeledSection } from '../../label2.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { PlainTextException3c81a0qh9m2e2 as PlainTextException } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments } from '../../files/attachmentFilePreview.mjs';
import { UnlockProjectRequestsb9zq5gbmeux as UnlockProjectRequest } from '../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from '../../../dialogs/GenericConfirmationDialog.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ProjectUnlockProposalDialog(lens, data, alternative) {
  alternative = alternative === VOID ? false : alternative;
  var tmp = alternative ? 'Propose Alternative' : 'Unlock Project';
  var tmp_0 = alternative ? 'Submit an alternative unlock proposal explaining what changes or clarifications are needed before you can agree to unlock. The other party can accept your alternative or propose their own.' : "The project can be unlocked via mutual agreement. Discuss resolution options with the other party through Stoze's messaging system or on-site, and then use this form to submit a formal request to unlock the project. If both parties agree the project will be unlocked and will be brought back to its state immediately before the lock. A new timer will be created allowing the project to be locked again in 14 days if no resolution is reached.";
  var tmp_1 = alternative ? 'Submit Alternative' : 'Submit Unlock Request';
  return new (TextAndFileInputDialog())(tmp, tmp_0, tmp_1, VOID, 35, VOID, VOID, VOID, ProjectUnlockProposalDialog$slambda_0(alternative, data, lens));
}
function viewUnlockProposalDialog(data, _this__u8e3s4, request, submittedByMe, lens) {
  var tmp = get_dialogStack();
  tmp.th2(VOID, true, ($this$dialog, close) => {
    var tmp = $this$dialog.ibb(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, plus(get_rem(40), times(get_rem(20), coerceAtMost(request.q86_1.length / 2000.0, 1.0)))), $this$dialog.hbb(GroupedInformationSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$dialog.pc());
    var tmp0_elvis_lhs = $this$dialog.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
    $this$dialog.ebb(p, view);
    view.xbm(true);
    title(view, 'Unlock Project');
    body(view, submittedByMe ? 'Your unlock request has been sent to the other party for review. You will be notified when they respond.' : "The other party has submitted a request to unlock the project. Review their reasoning and, if you agree, accept to unlock the project and return it to its pre-locked state. \n\nIf you disagree, communicate through Stoze's messaging system to let them know why, or what to adjust, or submit an alternative unlock proposal of your own.");
    labeledSection(view, 'Request', ($this$labeledSection) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$labeledSection.pc());
      var tmp0_elvis_lhs = $this$labeledSection.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$labeledSection : tmp0_elvis_lhs;
      $this$labeledSection.ebb(p, view);
      view.xbm(true);
      body(view, request.q86_1);
      view.jbb(get_scrollingHorizontally(view), renderFiles(view, new (Constant())(_Constant___init__impl__v45mub(request.r86_1)), get_AppDimensions().qg2_1));
      $this$labeledSection.fbb(p, view);
      return Unit_instance;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    view_0.zb8(get_AppDimensions().ig2_1);
    if (!submittedByMe) {
      var tmp_0 = get_primaryButton(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (Button())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.ebb(p_1, view_1);
      specCenteredText(view_1, get_viewIsNarrow(view_1) ? 'Accept' : 'Accept & Unlock Project');
      onClick(view_1, VOID, VOID, viewUnlockProposalDialog$lambda$slambda_0(view_1, request));
      view_0.fbb(p_1, view_1);
      view_0.jbb(tmp_0, view_1);
      var tmp_1 = get_secondaryButton(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Button())(view_0.pc());
      var tmp0_elvis_lhs_2 = view_0.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
      view_0.ebb(p_2, view_2);
      specCenteredText(view_2, get_viewIsNarrow(view_2) ? 'Propose' : 'Propose Alternative');
      onClick(view_2, VOID, VOID, viewUnlockProposalDialog$lambda$slambda_2(lens, data));
      view_0.fbb(p_2, view_2);
      view_0.jbb(tmp_1, view_2);
    }
    var tmp_2 = get_textButton(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())(view_0.pc());
    var tmp0_elvis_lhs_3 = view_0.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
    view_0.ebb(p_3, view_3);
    if (get_viewIsNarrow(view_3))
      view_3.jbb(get_centered(view_3), body(view_3, 'Go Back'));
    else
      specCenteredText(view_3, 'Go Back');
    onClick(view_3, VOID, VOID, viewUnlockProposalDialog$lambda$slambda_4(close));
    view_0.fbb(p_3, view_3);
    view_0.jbb(tmp_2, view_3);
    view.fbb(p_0, view_0);
    $this$dialog.fbb(p, view);
    return $this$dialog.jbb(tmp, view);
  });
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp1_project = $this.uh2_1.jf8();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.uh2_1.jfy();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_elvis_lhs = tmp_0.j7c_1;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw PlainTextException().jcw('No project lock found.');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var tmp2_lock = tmp_1;
  var tmp3_submitted = session.ufw();
  var tmp4_submittedByClient = $this.vh2_1.xgj();
  var tmp_2 = resolveProjectAttachments($this.wh2_1.yh2_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp5_attachments = tmp_2;
  var tmp6_message = $this.wh2_1.xh2_1;
  var tmp_3 = session.nfw_1.zen(new (UnlockProjectRequest())(VOID, tmp1_project, tmp2_lock, tmp3_submitted, tmp4_submittedByClient, tmp6_message, tmp5_attachments), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  get_dialogStack().ugg();
  return Unit_instance;
}
var ProjectUnlockProposalDialog$slambda$slambdaClass;
function ProjectUnlockProposalDialog$slambda$slambda() {
  if (ProjectUnlockProposalDialog$slambda$slambdaClass === VOID) {
    class $ {
      constructor($data, $lens, $submission) {
        this.uh2_1 = $data;
        this.vh2_1 = $lens;
        this.wh2_1 = $submission;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ProjectUnlockProposalDialog$slambda$slambdaClass = $;
  }
  return ProjectUnlockProposalDialog$slambda$slambdaClass;
}
function ProjectUnlockProposalDialog$slambda$slambda_0($data, $lens, $submission) {
  var i = new (ProjectUnlockProposalDialog$slambda$slambda())($data, $lens, $submission);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ProjectUnlockProposalDialog$slambdaClass;
function ProjectUnlockProposalDialog$slambda() {
  if (ProjectUnlockProposalDialog$slambdaClass === VOID) {
    class $ {
      constructor($alternative, $data, $lens) {
        this.zh2_1 = $alternative;
        this.ah3_1 = $data;
        this.bh3_1 = $lens;
      }
      ch3($this$TextAndFileInputDialog, submission, $completion) {
        if (submission == null) {
          get_dialogStack().ugg();
          return Unit_instance;
        }
        var tmp = this.zh2_1 ? 'Submit Alternative?' : 'Submit Unlock Request?';
        var tmp_0 = this.zh2_1 ? 'This sends your alternative proposal to the other party. They can accept your proposal or respond with their own. The project remains locked until both parties agree.' : 'This sends your unlock request to the other party for review. They can accept to unlock the project or propose an alternative. The project remains locked until both parties agree.';
        confirmationDialog($this$TextAndFileInputDialog, tmp, tmp_0, 'Submit', VOID, VOID, VOID, VOID, VOID, VOID, ProjectUnlockProposalDialog$slambda$slambda_0(this.ah3_1, this.bh3_1, submission));
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.ch3(tmp, (p2 == null ? true : p2 instanceof Submission()) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ProjectUnlockProposalDialog$slambdaClass = $;
  }
  return ProjectUnlockProposalDialog$slambdaClass;
}
function ProjectUnlockProposalDialog$slambda_0($alternative, $data, $lens) {
  var i = new (ProjectUnlockProposalDialog$slambda())($alternative, $data, $lens);
  var l = ($this$TextAndFileInputDialog, submission, $completion) => i.ch3($this$TextAndFileInputDialog, submission, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.tfw().zfg_1.sfr($this.dh3_1.l86_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var updated = tmp_0;
  var tmp_1 = (it) => it.l86_1.equals($this.dh3_1.l86_1);
  session.nfw_1.ceo(tmp_1, (it) => updated);
  get_dialogStack().ugg();
  return Unit_instance;
}
var viewUnlockProposalDialog$lambda$slambda$slambdaClass;
function viewUnlockProposalDialog$lambda$slambda$slambda() {
  if (viewUnlockProposalDialog$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($request) {
        this.dh3_1 = $request;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    viewUnlockProposalDialog$lambda$slambda$slambdaClass = $;
  }
  return viewUnlockProposalDialog$lambda$slambda$slambdaClass;
}
function viewUnlockProposalDialog$lambda$slambda$slambda_0($request) {
  var i = new (viewUnlockProposalDialog$lambda$slambda$slambda())($request);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var viewUnlockProposalDialog$lambda$slambdaClass;
function viewUnlockProposalDialog$lambda$slambda() {
  if (viewUnlockProposalDialog$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, $request) {
        this.eh3_1 = $$this$button;
        this.fh3_1 = $request;
      }
      sao($completion) {
        confirmationDialog(this.eh3_1, 'Accept and Unlock Project?', 'This will return the project to its pre-locked state. This means any disputes that existed before the lock will still need to be resolved. A new timer will be created allowing the project to be locked again in 14 days if no resolution is reached. This cannot be undone.', 'Accept and Unlock', VOID, VOID, VOID, VOID, VOID, VOID, viewUnlockProposalDialog$lambda$slambda$slambda_0(this.fh3_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    viewUnlockProposalDialog$lambda$slambdaClass = $;
  }
  return viewUnlockProposalDialog$lambda$slambdaClass;
}
function viewUnlockProposalDialog$lambda$slambda_0($$this$button, $request) {
  var i = new (viewUnlockProposalDialog$lambda$slambda())($$this$button, $request);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var viewUnlockProposalDialog$lambda$slambdaClass_0;
function viewUnlockProposalDialog$lambda$slambda_1() {
  if (viewUnlockProposalDialog$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($lens, $data) {
        this.gh3_1 = $lens;
        this.hh3_1 = $data;
      }
      sao($completion) {
        get_dialogStack().nd6(ProjectUnlockProposalDialog(this.gh3_1, this.hh3_1, true));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    viewUnlockProposalDialog$lambda$slambdaClass_0 = $;
  }
  return viewUnlockProposalDialog$lambda$slambdaClass_0;
}
function viewUnlockProposalDialog$lambda$slambda_2($lens, $data) {
  var i = new (viewUnlockProposalDialog$lambda$slambda_1())($lens, $data);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var viewUnlockProposalDialog$lambda$slambdaClass_1;
function viewUnlockProposalDialog$lambda$slambda_3() {
  if (viewUnlockProposalDialog$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($close) {
        this.ih3_1 = $close;
      }
      sao($completion) {
        this.ih3_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    viewUnlockProposalDialog$lambda$slambdaClass_1 = $;
  }
  return viewUnlockProposalDialog$lambda$slambdaClass_1;
}
function viewUnlockProposalDialog$lambda$slambda_4($close) {
  var i = new (viewUnlockProposalDialog$lambda$slambda_3())($close);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  ProjectUnlockProposalDialog as ProjectUnlockProposalDialogftazpb7o94qs,
  viewUnlockProposalDialog as viewUnlockProposalDialog1s7xyjel5pmhj,
};
//endregion

//# sourceMappingURL=unlockProjectDialogs.mjs.map
